import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";

export const SendRequestAPI = createAsyncThunk(
    "SendRequestAPI",
    async (data) => {
        try {
            const response = await api.post(endpoints.sendReqToWorker(), data)
            return response
        } catch (error) {
            console.log(error);
        }
    }
)

const initialState = {
    loading: false,
}

const ManageRequestSlice = createSlice({
    initialState,
    name: "ManageRequestSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(SendRequestAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(SendRequestAPI.fulfilled, (state, action) => {
            state.loading = false
        })

        builder.addCase(SendRequestAPI.rejected, (state, action) => {
            state.loading = false
            if (action.payload && action.payload.message) {
                toast.error(action.payload.message);
            } else {
                toast.error("An error occurred. Please try again.");
            }
        })
    }
})

const { } = ManageRequestSlice.actions
export default ManageRequestSlice.reducer